// extracted by mini-css-extract-plugin
export default {"GP_wrapper":"GrowthPlan_GP_wrapper__93MEl","GP_inner_wrapper":"GrowthPlan_GP_inner_wrapper__EMUVW","section_wrapper":"GrowthPlan_section_wrapper__9SR+g"};